import SearchIcon from '@mui/icons-material/Search';
import { Box, Button, InputAdornment, TextField } from '@mui/material';
import { spacingFunction } from '../../../../theme/tokens';
import useTemplateSx from '../../hooks/useTemplateSx';
import TemplateSearchableSelect from '../shared/TemplateSearchableSelect';

export default function TemplateUsersFilters({
  search,
  onSearchChange,
  statusFilter,
  onStatusChange,
  statusOptions,
  onClear,
  hasActiveFilters,
}) {
  const styles = useTemplateSx();

  return (
    <Box sx={styles.filtersToolbar}>
      <Box sx={styles.filtersBar}>
        <TextField
          size="small"
          placeholder="Search users..."
          value={search}
          onChange={(event) => {
            const value = event.target.value
              .replace(/^\s+/, '')
              .replace(/\s{2,}/g, ' ');
            onSearchChange(value);
          }}
          sx={{
            ...styles.filterSearch,
            '& .MuiOutlinedInput-notchedOutline': {
              top: spacingFunction(0),
            },
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start" sx={{ mr: 0 }}>
                <SearchIcon sx={{ fontSize: 18, color: 'text.secondary' }} />
              </InputAdornment>
            ),
          }}
        />

        <Box sx={{ ...styles.filterField, ...styles.templateUsersStatusField }}>
          <TemplateSearchableSelect
            variant="filter"
            label=""
            placeholder="All statuses"
            options={statusOptions}
            value={statusFilter}
            onChange={onStatusChange}
            getOptionLabel={(option) => option?.label ?? ''}
            isOptionEqualToValue={(a, b) => a?.value === b?.value}
          />
        </Box>

        {hasActiveFilters ? (
          <Button
            variant="outlined"
            size="small"
            onClick={onClear}
            sx={styles.filterClearButton}
          >
            Clear
          </Button>
        ) : null}
      </Box>
    </Box>
  );
}
